import styled from 'styled-components'

import { HeadlineText } from '@/ui/atoms/headline-text'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const FiltersSidebarPanel = styled.div(({ theme }) => {
  return `
    background: ${theme.colors.white};
    border: .1rem solid ${theme.colors.grey.light4};
    display: none;
    padding: 0;

    ${MEDIA_QUERIES(theme).large}{
      display: block;
    }
  `
})

export const FiltersSidebarTitle = styled(HeadlineText)(
  ({ theme }) => `
  padding: 1.4rem ${theme.spacing.default};
`
)

export const SkyscraperTopLeftAdSlotContainerWrapper = styled.div(
  () => `
    height: calc(600px + 200vh);
  `
)

export const SkyscraperTopLeftAdSlotContainer = styled.div(
  ({ theme }) => `
    display: none;
    justify-content: center;
    margin-top:  ${theme.spacing.large};
    overflow: hidden;
    position: sticky;
    top: 9rem;

    ${MEDIA_QUERIES(theme).large}{
      display: flex;
    }
  `
)

export const SkyscraperBottomLeftAdSlotContainerWrapper = styled.div(
  () => `
    height: calc(600px + 200vh);
  `
)

export const SkyscraperBottomLeftAdSlotContainer = styled.div(
  ({ theme }) => `
    display: none;
    justify-content: center;
    margin-top: 63vh;
    overflow: hidden;
    position: sticky;
    top: 9rem;

    ${MEDIA_QUERIES(theme).large}{
      display: flex;
    }
  `
)
